import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CommonUtilities {
    renderComponentsBasedOnRole(funcCompMapping, componentList) {
        funcCompMapping = {};
        for(var i=0;i<componentList.length;i++) {
            funcCompMapping[componentList[i].componentNm] = componentList[i].componentActiveFlag;
        }
        return funcCompMapping;
    }

    sortObjectForDropdown(obj, sortparam) {

        return obj.sort((a,b) => (a[sortparam].toLowerCase() > b[sortparam].toLowerCase()) ? 1 : ((b[sortparam].toLowerCase() > a[sortparam].toLowerCase()) ? -1 : 0));
    }
    sortObjectForDropdownDescending(obj, sortparam) {

        return obj.sort((a,b) => (a[sortparam].toLowerCase()< b[sortparam].toLowerCase()) ? 1 : ((b[sortparam].toLowerCase() > a[sortparam].toLowerCase()) ? -1 : 0));
    }

    sortArrayForDropdown(arr) {
        return arr.sort((a,b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : (b.toLowerCase() > a.toLowerCase()) ? -1: 0);
    }
    sortObjectForDropdownNumeric(obj, sortparam) {
        return obj.sort((a,b) => (a[sortparam] > b[sortparam]) ? 1 : ((b[sortparam] > a[sortparam]) ? -1 : 0));
    }
}